import { render, staticRenderFns } from "./KaufschutzRateList.vue?vue&type=template&id=18f6ae83&scoped=true&"
import script from "./KaufschutzRateList.vue?vue&type=script&lang=js&"
export * from "./KaufschutzRateList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18f6ae83",
  null
  
)

export default component.exports